module.exports = __webpack_public_path__ + "img/7.0b29b262.png";